import { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { PATTERN_PATH, getPagePatterns } from '../../api/patternApi';
import { useApiProgress } from '../../hooks/ApiProgress';
import { toast } from 'react-toastify';
import { PRODUCT_TYPES } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import { PRODUCT_COLLECTION_PATH, getProductCollectionById, updateProductCollection } from '../../api/productCollectionApi';
import { PRODUCT_PATH, addProduct, deleteProduct, getAllProducts, updateProduct } from '../../api/productApi';
import useFirstRender from '../../hooks/FirstRender';
import { Dialog, Transition } from '@headlessui/react';
import { translateProductType } from '../../utils/translator';
import { FaPlus } from 'react-icons/fa';
import { RxCross1 } from 'react-icons/rx';
import { COLOR_PATH, getPageColors } from '../../api/colorApi';
import { WEIGHT_PATH, getPageWeights } from '../../api/weightApi';
import { AiFillEdit } from 'react-icons/ai';
import { updateCollectionAction } from '../../redux/feature/productSlice';
import DeleteModal from '../../components/DeleteModal';
import ProductTypePicker from '../../components/product/ProductTypePicker';
import ColorPicker from '../../components/color/ColorPicker';
import WeightPicker from '../../components/weight/WeightPicker';
import PatternPicker from '../../components/pattern/PatternPicker';

const ProductEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const isFirstRender = useFirstRender()
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [collection, setCollection] = useState({
        code: "",
        name: "",
        hasVariation: false,
        type: undefined,
        variations: []
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${PRODUCT_COLLECTION_PATH}`, false)
    const pendingApiCallVariations = useApiProgress('get', `${PRODUCT_PATH}/all`, false)
    const pendingApiCallLoading = useApiProgress('get', `${PRODUCT_COLLECTION_PATH}`, false)
    const pendingApiCallDeleteVariation = useApiProgress('delete', `${PRODUCT_PATH}`, false)

    const [isOpenVariationModal, setIsOpenVariationModal] = useState(false)
    const [isOpenVariationDeleteModal, setIsOpenVariationDeleteModal] = useState(false)
    const [deleteVariationId, setDeleteVariationId] = useState()

    const [variation, setVariation] = useState({})

    const [colorPage, setColorPage] = useState({
        content: []
    })

    const [patternPage, setPatternPage] = useState({
        content: []
    })

    const [weightPage, setWeightPage] = useState({
        content: []
    })

    const pendingApiCallColor = useApiProgress('get', `${COLOR_PATH}/page`, false)
    const pendingApiCallPattern = useApiProgress('get', `${PATTERN_PATH}/page`, false)
    const pendingApiCallWeight = useApiProgress('get', `${WEIGHT_PATH}/page`, false)

    const [colorQuery, setColorQuery] = useState('')
    const [patternQuery, setPatternQuery] = useState('')
    const [weightQuery, setWeightQuery] = useState('')

    const [searchTimerColor, setSearchTimerColor] = useState();
    const [searchTimerPattern, setSearchTimerPattern] = useState();
    const [searchTimerWeight, setSearchTimerWeight] = useState();

    const searchingColor = async (params) => {
        if (searchTimerColor) clearTimeout(searchTimerColor);
        let timer = setTimeout(() => {
            getPageColors(params)
                .then(res => {
                    setColorPage(res.data)
                })
        }, 500);
        setSearchTimerColor(timer);
    }

    const searchingPattern = async (params) => {
        if (searchTimerPattern) clearTimeout(searchTimerPattern);
        let timer = setTimeout(() => {
            getPagePatterns(params)
                .then(res => {
                    setPatternPage(res.data)
                })
        }, 500);
        setSearchTimerPattern(timer);
    }

    const searchingWeight = async (params) => {
        if (searchTimerWeight) clearTimeout(searchTimerWeight);
        let timer = setTimeout(() => {
            getPageWeights(params)
                .then(res => {
                    setWeightPage(res.data)
                })
        }, 500);
        setSearchTimerWeight(timer);
    }

    const onClickLoadMoreColor = () => {
        if (!colorPage.last) {
            loadColors({ search: colorQuery, lastId: colorPage.content[colorPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMorePattern = () => {
        if (!patternPage.last) {
            loadPatterns({ search: patternQuery, lastId: patternPage.content[patternPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreWeight = () => {
        if (!weightPage.last) {
            loadWeights({ search: weightQuery, lastId: weightPage.content[weightPage.content.length - 1]?.id })
        }
    }

    const loadColors = (params) => {
        !pendingApiCallColor &&
            getPageColors(params)
                .then(res => {
                    setColorPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadPatterns = (params) => {
        !pendingApiCallPattern &&
            getPagePatterns(params)
                .then(res => {
                    setPatternPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadWeights = (params) => {
        !pendingApiCallWeight &&
            getPageWeights(params)
                .then(res => {
                    setWeightPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingColor({ search: colorQuery })
    }, [colorQuery])

    useEffect(() => {
        !isFirstRender && searchingPattern({ search: patternQuery })
    }, [patternQuery])

    useEffect(() => {
        !isFirstRender && searchingWeight({ search: weightQuery })
    }, [weightQuery])

    useEffect(() => {
        getProductCollectionById(id)
            .then(res => setCollection(res.data))
            .then(() => getAllProducts({ collectionId: id }).then(res => {
                setCollection(prevState => ({ ...prevState, variations: res.data }))
            }))
            .then(() => console.log(collection))
        colorPage.content.length === 0 && loadColors({ size: 20 })
        patternPage.content.length === 0 && loadPatterns({ size: 20 })
        weightPage.content.length === 0 && loadWeights({ size: 20 })
    }, [id])


    if (pendingApiCallLoading || pendingApiCallVariations) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    const onSubmit = () => {
        const body = {
            code: collection.code,
            name: collection.name,
            type: collection.type,
            hasVariation: collection.hasVariation,
            variations: collection.variations.map(v => {
                return {
                    name: v.name,
                    colorId: v.color?.id,
                    patternId: v.pattern?.id,
                    weightId: v.weight?.id,
                    description: v.description
                }
            })
        }
        updateProductCollection(id, body)
            .then(res => {
                setCollection(prevState => ({ ...res.data, variations: prevState.variations }))
                toast.success('Ürün güncellendi')
                closeTab()
            }).catch(err => {
                toast.error('Hata')
            })
    }

    const addVariation = () => {
        const body = {
            name: variation.name,
            colorId: variation.color?.id,
            patternId: variation.pattern?.id,
            weight: variation.weight?.id,
            collectionId: id
        }
        if (variation.id) {
            updateProduct(variation.id, body)
                .then(res => {
                    setCollection(prevState => ({
                        ...prevState,
                        variations: prevState.variations.map(v => {
                            if (v.id === res.data.id) return res.data
                            else return v
                        })
                    }))
                    toast.success('Varyasyon güncellendi')
                    setIsOpenVariationModal(false)
                    setVariation({})
                })
        } else {
            addProduct(body)
                .then(res => {
                    collection.variations.push(res.data)
                    setCollection(collection)
                    toast.success('Varyasyon eklendi')
                    setIsOpenVariationModal(false)
                    setVariation({})
                }).then(() => {
                    getProductCollectionById(id)
                        .then(res => {
                            dispatch(updateCollectionAction(res.data))
                        })
                })
        }
    }

    const onClickDeleteVariation = () => {
        if (collection.variations.length === 1) {
            toast.error('En az bir adet varyasyon olmalıdır')
            return;
        }
        deleteProduct(deleteVariationId)
            .then(res => {
                setCollection(prevState => ({ ...prevState, variations: prevState.variations.filter((v) => v.id !== deleteVariationId) }))
                setDeleteVariationId()
                setIsOpenVariationDeleteModal(false)
                toast.success('Varyasyon silindi')
            })
            .then(() => {
                getProductCollectionById(id)
                    .then(res => {
                        dispatch(updateCollectionAction(res.data))
                    })
            })
    }

    const onClickEditVariation = (variation) => {
        setVariation(variation)
        setIsOpenVariationModal(true)
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='w-1/3'>
                <label className='text-xl mb-5 block'>Ürün Düzenle</label>
                <Input
                    label='Ortalama Maliyet (USD/m)'
                    error={errors.code}
                    value={collection.averageCost}
                    disabled
                />
                <Input
                    label='Ürün Kodu'
                    name='code'
                    placeholder='Ürün kodu girin'
                    error={errors.code}
                    value={collection.code}
                    onChange={e => onChange(e, setCollection, setErrors)}
                />
                <Input
                    label='Ürün Adı'
                    name='name'
                    placeholder='Ürün adı girin'
                    value={collection.name}
                    onChange={e => onChange(e, setCollection, setErrors)}
                />

                {/* PRODUCT TYPE */}
                <ProductTypePicker
                    label="Ürün Tipi"
                    value={collection.type}
                    onChange={(type) => setCollection(prevState => ({ ...prevState, type }))}
                    text={translateProductType(collection.type) || 'Ürün tipi seçin'}
                    items={PRODUCT_TYPES}
                    error={errors.type}
                />

                <div className='flex items-center gap-x-2 mb-3'>
                    <label htmlFor='hasVariaton'>Varyasyonu var</label>
                    <input type='checkbox' id='hasVariaton' defaultChecked={collection.hasVariation} onChange={e => setCollection(prevState => ({ ...prevState, hasVariation: e.target.checked }))} />
                </div>

                {/* VARIATION */}
                {
                    collection.hasVariation &&
                    <div className='mb-5'>
                        <div className='flex items-center gap-x-2 mb-1'>
                            <label>Varyasyon</label>
                            <FaPlus
                                className='cursor-pointer hover:text-blue-700 duration-150'
                                onClick={() => {
                                    setIsOpenVariationModal(true)
                                    setVariation({})
                                }}
                            />
                        </div>
                        <label className='text-xs'>
                            {collection.variations?.length > 0 ? `${collection.variations?.length} adet varyasyon eklediniz` : 'Henüz varyasyon eklemediniz. Lütfen en az bir adet ekleyin.'}
                        </label>
                        <label className='text-xs mb-3 block'></label>
                        {collection.variations?.length > 0 &&
                            <div className='h-96 overflow-scroll bg-white p-3 rounded-md shadow-md border'>
                                {
                                    collection.variations.map((variation, index) => (
                                        <div key={index} className='relative border rounded-md p-4 mb-3 shadow-lg'>
                                            {variation.name && <label className='block'>Ad : {variation.name} </label>}
                                            {variation.color && <label className='block'>Renk : {variation.color?.code} </label>}
                                            {variation.pattern && <label className='block'>Desen : {variation.pattern?.code} </label>}
                                            {variation.weight && <label className='block'>Gramaj : {variation.weight?.code} </label>}
                                            {variation.description && <label className='block'>Açıklama : {variation.description} </label>}
                                            <label> Ortalama Maliyet : {variation.averageCost} USD/m </label>
                                            <div>
                                                <AiFillEdit className='absolute top-4 right-8 cursor-pointer' onClick={() => onClickEditVariation(variation)} />
                                                <RxCross1 className='absolute top-4 right-2 cursor-pointer' onClick={() => { setDeleteVariationId(variation.id); setIsOpenVariationDeleteModal(true) }} />
                                            </div>

                                        </div>
                                    ))
                                }
                            </div>
                        }
                        {errors.variations && <label className='text-red-700'>{errors.variations} </label>}
                    </div>
                }
            </div>
            <div>
                <Button text='Kaydet' variant='green' onClick={onSubmit} />
            </div>

            {/*ADD VARIATION MODAL */}
            <Transition appear show={isOpenVariationModal} as={Fragment}>
                <Dialog as="div" onClose={() => setIsOpenVariationModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                    >
                                        Yeni Varyasyon
                                    </Dialog.Title>
                                    <Input
                                        label='Varyasyon Adı'
                                        placeholder='Varyasyon adı girin...'
                                        name="name"
                                        value={variation.name}
                                        onChange={e => onChange(e, setVariation)}
                                    />

                                    {/* COLOR PICKER */}
                                    <ColorPicker
                                        label='Renk'
                                        pendingApiCall={pendingApiCallColor}
                                        state={variation.color}
                                        setState={(value) => setVariation(prevState => ({ ...prevState, color: value }))}
                                        query={colorQuery}
                                        setQuery={setColorQuery}
                                        error={errors.colorId}
                                        page={colorPage}
                                        setErrors={prevState => ({ ...prevState, colorId: undefined })}
                                        onClickClear={() => setVariation(prevState => ({ ...prevState, color: undefined }))}
                                        onClickLoadMore={() => onClickLoadMoreColor()}
                                    />

                                    {/* PATTERN PICKER */}
                                    <PatternPicker
                                        label='Desen'
                                        pendingApiCall={pendingApiCallPattern}
                                        state={variation.pattern}
                                        setState={(value) => setVariation(prevState => ({ ...prevState, pattern: value }))}
                                        query={patternQuery}
                                        setQuery={setPatternQuery}
                                        error={errors.patternId}
                                        page={patternPage}
                                        setErrors={prevState => ({ ...prevState, patternId: undefined })}
                                        onClickClear={() => setVariation(prevState => ({ ...prevState, pattern: undefined }))}
                                        onClickLoadMore={() => onClickLoadMorePattern()}
                                    />

                                    {/* WEIGHT PICKER */}
                                    <WeightPicker
                                        label='Gramaj'
                                        pendingApiCall={pendingApiCallWeight}
                                        state={variation.weight}
                                        setState={(value) => setVariation(prevState => ({ ...prevState, weight: value }))}
                                        query={weightQuery}
                                        setQuery={setWeightQuery}
                                        error={errors.weightId}
                                        page={weightPage}
                                        setErrors={prevState => ({ ...prevState, weightId: undefined })}
                                        onClickClear={() => setVariation(prevState => ({ ...prevState, weight: undefined }))}
                                        onClickLoadMore={() => onClickLoadMoreWeight()}
                                    />

                                    <Textarea
                                        label='Açıklama'
                                        name='description'
                                        onChange={e => onChange(e, setVariation)}
                                        value={variation.description}
                                        placeholder='Açıklama girin...'
                                    />
                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenVariationModal(false)}
                                        >
                                            İptal
                                            {pendingApiCall && <Spinner />}
                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 disabled:bg-blue-100"
                                            onClick={addVariation}
                                            disabled={!variation.color && !variation.pattern && !variation.weight}
                                        >
                                            Ekle
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
            <DeleteModal
                isOpen={isOpenVariationDeleteModal}
                closeModal={() => setIsOpenVariationDeleteModal(false)}
                onClick={onClickDeleteVariation}
                pendingApiCall={pendingApiCallDeleteVariation}
            />

        </div>
    )
}

export default ProductEditPage